"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lettere": {
    "f3a64088": [{
      "hkey": "5952012f",
      "slug": "lettere",
      "name": "Lettere",
      "primary": true,
      "skipSearch": false
    }],
    "depugliano": [{
      "hkey": "5952012f",
      "slug": "lettere",
      "name": "Lettere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ffd7d751": [{
      "hkey": "5952012f",
      "slug": "lettere",
      "name": "Lettere",
      "primary": true,
      "skipSearch": false
    }],
    "fuscoli": [{
      "hkey": "5952012f",
      "slug": "lettere",
      "name": "Lettere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e1ed6f55": [{
      "hkey": "5952012f",
      "slug": "lettere",
      "name": "Lettere",
      "primary": true,
      "skipSearch": false
    }],
    "orsano": [{
      "hkey": "5952012f",
      "slug": "lettere",
      "name": "Lettere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7b981e38": [{
      "hkey": "5952012f",
      "slug": "lettere",
      "name": "Lettere",
      "primary": true,
      "skipSearch": false
    }],
    "san-lorenzo": [{
      "hkey": "5952012f",
      "slug": "lettere",
      "name": "Lettere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;